import type { Error } from '../types';

import { TXTCLI_Required } from './required.messages';

export const required =
  (message: Error['message'] | null = TXTCLI_Required) =>
  (value: string) => ({
    valid: !!value,
    message: message !== null ? message : undefined
  });
